var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-page-shell',{attrs:{"title":"已完成"}},[_c('order-workbench',{attrs:{"extra-query-params":{ is_archived: 1 },"show-create-button":false,"show-title":false}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50d8cceb","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/views/ArchivedOrderList.vue
// module id = e9Bt
// module chunks = 0